const printPart = (divId) => {
  try {
      const elementToPrint = document.getElementById(divId);
      if (!elementToPrint) {
          console.error(`Element with id ${divId} not found.`);
          return;
      }

      const printContents = elementToPrint.innerHTML;
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const iframeWindow = iframe.contentWindow;
      if (!iframeWindow) {
          console.error("Failed to get iframe content window.");
          document.body.removeChild(iframe);
          return;
      }

      const doc = iframeWindow.document;
      doc.open();
      doc.write("<html><head><title>Print</title>");

      // Copy styles from the main document head
      const styles = document.querySelectorAll(
          'style, link[rel="stylesheet"]',
      );
      styles.forEach((style) => {
          if (style.tagName === "LINK") {
              const link = style;
              const href = link.href;
              const newHref = href.includes("?")
                  ? `${href}&t=${Date.now()}`
                  : `${href}?t=${Date.now()}`;
              doc.write(`<link rel="stylesheet" href="${newHref}">`);
          } else {
              doc.write(style.outerHTML);
          }
      });

      doc.write("</head><body>");
      doc.write(printContents);
      doc.write("</body></html>");
      doc.close();

      iframe.onload = () => {
          iframeWindow.focus();
          iframeWindow.print();
          document.body.removeChild(iframe);
      };
  } catch (error) {
      console.error("An error occurred while trying to print:", error);
  }
};

// Assuming you have a button to trigger the print
document.querySelectorAll('.printButton').forEach((button) => {
  button.addEventListener('click', () => {
    const printId = button.getAttribute('data-print');
    if (printId) {
      printPart(printId);
    } else {
      console.error("No data-print attribute found on the button.");
    }
  });
});
